import React from "react";
import { type FreefieldInputProps } from "shared/utils/freeFields/models";
import moment from "moment";
import { OptionalDatePicker } from "components/DatePicker/OptionalDatePicker";
import { isFreeFieldDateEmpty } from "shared/utils/freeFields/utils";

const FreefieldDate = (props: FreefieldInputProps) => {
  const [date, setDate] = React.useState(!isFreeFieldDateEmpty(props.initialValue) ? moment.utc(props.initialValue) : undefined);

  const onDateChange = (date: moment.Moment) => {
    setDate(date);
    props.onChange(date ? date.toISOString() : undefined);
  };

  return <OptionalDatePicker
    validatorKey={`freefieldDate${props.reference}`}
    minDate={moment(serverReference.constants.appointment.minDate)}
    maxDate={moment(serverReference.constants.appointment.maxDate)}
    value={date}
    onChange={onDateChange}
  />;
};

export default FreefieldDate;